var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.barcode))]),_c('button',{on:{"click":function($event){return _vm.onDecode('123456')}}},[_vm._v("FAKE BARCODE")]),_c('div',[_c('qrcode-stream',{on:{"decode":_vm.onDecode}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }